// Where tour requests are sent. Paste a Formspree (https://formspree.io) or Web3Forms
// endpoint here to deliver requests straight to the school inbox. While this is empty,
// the form falls back to opening the visitor's email app with the request pre-filled.
export const TOUR_FORM_ENDPOINT = "https://formspree.io/f/mqpawban";

export const SCHOOL_EMAIL = "Stephanie@LIMAcademy.com";
export const SCHOOL_PHONE = "954 722-4880";
export const SCHOOL_PHONE_LINK = "tel:+19547224880";
export const INSTAGRAM_URL = "https://www.instagram.com/learninginmotionacademy/";
export const TOUR_REEL_ID = "DaS-PBoAEBP";
